var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 320.267,
    cy: 384.533,
    r: 17.133
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.734,
    cy: 256,
    r: 17.133
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.867 0c-6.682 0-12.548 4.427-14.401 10.847s.775 13.299 6.43 16.859c.572.36 57.238 36.588 57.238 83.693 0 22.736-18.498 41.233-41.234 41.233s-41.233-18.497-41.233-41.233c0-18.096 9.707-27.722 10.829-28.773 5.748-4.618 7.108-12.592 3.437-19-3.69-6.439-11.717-9.065-18.635-6.373-3.891 1.512-154.164 61.797-154.164 230.88 0 123.441 100.426 223.867 223.866 223.867s223.866-100.426 223.866-223.867c0-184.246-182.201-288.133-255.999-288.133zm-79.267 256c0-25.989 21.144-47.133 47.133-47.133s47.133 21.144 47.133 47.133-21.144 47.133-47.133 47.133-47.133-21.144-47.133-47.133zm58.847 153.971c-4.918 6.148-14.308 7.763-21.083 2.342-6.469-5.175-7.518-14.614-2.342-21.083l128.533-160.667c5.175-6.468 14.613-7.518 21.083-2.342 6.469 5.175 7.518 14.614 2.342 21.083zm116.82 21.696c-25.989 0-47.133-21.144-47.133-47.133s21.144-47.133 47.133-47.133 47.133 21.144 47.133 47.133-21.144 47.133-47.133 47.133z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/percentage_icon.f4690ba7.svg";
export { ForwardRef as ReactComponent };